import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";
import { beforeSendHigienizado } from "@/lib/sentry-scrub";
import { ErrorBoundary } from "@/components/ErrorBoundary";

if (import.meta.env.VITE_SENTRY_DSN && import.meta.env.PROD) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.2,
    ignoreErrors: ["ResizeObserver loop", "Non-Error promise rejection"],
    // Sem isto, CPF, e-mail e telefone que caiam numa mensagem de erro saem do
    // país sem ninguém ter decidido. Ver lib/sentry-scrub.ts.
    beforeSend: beforeSendHigienizado,
  });
}

// O limite de erro precisa ficar AQUI, fora de tudo.
//
// Dentro do `App` ele já existia, mas montado abaixo de `QueryClientProvider`,
// `TooltipProvider`, `BrowserRouter`, `AuthProvider`, `RoleProvider`,
// `ActivePanelProvider` e `SubscriptionProvider`. Um boundary só pega o que
// acontece ABAIXO dele: exceção lançada por qualquer um desses sete escapava e
// o React desmontava a árvore inteira — tela branca, sem uma palavra na tela e
// sem caminho de volta. E é justamente ali que mora o que pode falhar na
// largada: decodificar a sessão, ler o papel, resolver o painel ativo.
//
// O de dentro continua onde está, de propósito: quando o erro é de uma rota, é
// ele quem responde primeiro, e o de fora nunca chega a ser acionado.
createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
);

// Registra Service Worker para PWA (push notifications + cache offline)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .catch(() => {
        // SW registration failure é silenciosa — app funciona normalmente
      });
  });
}
